// Import the Angular Component decorator and OnInit lifecycle interface.
import { Component, OnInit } from '@angular/core';

// Define the Angular component metadata for the HSR Training page.
@Component({
  // Register the HTML selector used for this component.
  selector: 'app-hsr-training',
  // Link the component to its HTML template file.
  templateUrl: './hsr-training.component.html',
  // Link the component to its component-specific SCSS file.
  styleUrls: ['./hsr-training.component.scss']
})
// Export the HSR Training component and use the standard OnInit structure used by the project.
export class HsrTrainingComponent implements OnInit {
  // Store the Section 67 HSR entitlements displayed on the page.
  readonly entitlements = [
    // Explain the entitlement to paid time away from work for HSR training.
    'Paid time off work to attend HSR training — the employer pays for time away from work',
    // Explain the entitlement to have reasonable training-related costs covered.
    'All reasonable costs covered — including course fees, travel, and accommodation where applicable',
    // Explain the elected HSR's right to choose a WorkSafe-approved training provider.
    'The right to choose their HSR training course from any WorkSafe-approved provider',
    // Explain the initial and annual refresher training duration entitlement.
    'Up to 5 days of initial (first-year) HSR training, plus 1 day per year of refresher training'
  ];

  // Store the required details shown for the Certificate of Attendance.
  readonly certificates = [
    // Display the approved full course title requirement.
    'Full course title (as WorkSafe-approved)',
    // Display the participant-name requirement.
    'Participant name',
    // Display the training-date requirement.
    'Training dates',
    // Display ECB Training Services as the provider requirement.
    'ECB Training Services as the provider',
    // Display the unique certificate identifier requirement.
    'A unique certificate ID',
    // Display the authorised-signature requirement.
    'Authorised signature',
    // Display the approved WorkSafe logo and approval-statement requirement.
    'Correct WorkSafe logo and WorkSafe approval statement',
    // Display the certificate issue-date requirement.
    'Date of issue'
  ];

  // Keep page initialisation in a dedicated method to match the existing component structure used in the project.
  loadPageData(): void {
    // This page currently uses static content from the approved brief, so no API call is required here.
  }

  // Run the component initialisation logic when Angular creates the page.
  ngOnInit(): void {
    // Load any data required by the page.
    this.loadPageData();
  }
}
